import React, { HTMLProps } from 'react'

import ButtonGroupPagination from '../../../ui/common/ButtonGroupPagination'
import Text from '../../../ui/Text'
import useText from '../../hooks/useText'

type ListPageHeaderProps = {
    isLoading: boolean
    amount?: number
    pageSize: number
    setCurrentPage: (page: number) => void
    setPageSize: (pageSize: number) => void
} & HTMLProps<HTMLDivElement>

const ListPageHeader = ({ isLoading, amount = 0, pageSize, setPageSize, setCurrentPage }: ListPageHeaderProps) => {
    const text = useText()
    return (
        <div className="flex align-items-start justify-content-between my-4">
            {!isLoading && (
                <>
                    <div>{text('msgChargersFound', { amount })}</div>
                    <div className="text-right">
                        <div data-testid="pagination-title">
                            <Text code="msgResultPage" />
                            <span>:</span>
                        </div>
                        <ButtonGroupPagination
                            value={pageSize}
                            onChange={(value: number) => {
                                setPageSize(value)
                                setCurrentPage(0)
                            }}
                            data-testid="button-paginate-group"
                        />
                    </div>
                </>
            )}
        </div>
    )
}

export default ListPageHeader
